
import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Container } from 'react-bootstrap';
import headerImg from '../assets/images/pushtheboat_logo.svg';

export default class PoemModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            poem: this.props.poem
        };
    }

    componentDidMount() {

    }

    render() {

        // try {
        //     document.getElementById("audio-src").src = "this.state.selectedMarker.audio";
        //     document.getElementById("audio-control").load();
        // } catch (e) {
        //     console.log(e);
        // }
        return (
            <div className="modal-overview">
                <span className="close-modal" onClick={() => this.props.closeModal()}>X</span>
                <Container>
                    <br />
                    <br />
                    <br />
                    <Row>
                        <h1>{this.state.poem.poemTitle}</h1>
                        <span>by</span>
                        <h1>{this.state.poem.poetName}</h1>
                        <span>at</span>
                        <h1>{this.state.poem.locationName}</h1>
                        <div className="audio-holder">
                            <audio id="audio-control" controls>
                                <source id="audio-src" src={`https://ptbo-assets.s3.eu-west-1.amazonaws.com/audio/${this.state.poem.audio}`} type="audio/mpeg" />
                            </audio>
                        </div>
                    </Row>
                    <iframe
                        title="iframe"
                        width="300"
                        height="200"
                        style={{border:0}}
                        loading="lazy"
                        allowfullscreen
                        src={`https://www.google.com/maps/embed/v1/streetview?key=AIzaSyABlfv-r4PlAXclHAo4iAl9eaQBkr78lyY&location=${this.state.poem.coordinates}
                        &heading=210
                        &pitch=10
                        &fov=35`}
                    >
                    </iframe>
                </Container>

            </div>
        );
    }
}
